// removed by extract-text-webpack-plugin
module.exports = {"banner":"_1L45HTBMxlXGKcWR7vVl73","banner_hidden":"_2JtPhFjSD4-q_toPxxauVf","banner_full_width":"_35N2DhBDS1e55qvdYbAyx7","loader":"_3OD6iWXR3-GjW8QX4i7WEn","error":"_2S6YG9qNT4sst5maCWctQ3","message":"_2Y5aqn9tTxP7SpDOQ0BKsw","icon":"_1KrjK8YdOkwQ8oK0x-xfs0","spin":"_10_iPfdNkWZIk-WxqlSI_6","loading_inline":"_3wtrXem-WoL_O-wKEal5v-","loading_spinner":"ww7nNxgGpaYtgXGe-rsXK"};


//////////////////
// WEBPACK FOOTER
// ./lib/mkjs/style.less
// module id = 32
// module chunks = 0